const initialState = () => ({
  loading: false,
  sendingMessage: false,
  sendingFiles: false,
  messageToSend: '',
  messageToSendRaw: '',
  filesToSend: [],
  customerTyping: false,
  customerTypingInterval: null,
  showEditor: true,
  searchResult: [],
})

export const state = initialState()

export const getters = {
  /*
   * check the configured autocomplete number of results to slice or not the results
   */
  searchResult: (state, getters, rootState) =>
    rootState.Widget.bot.autocompleteNumResults
      ? state.searchResult.slice(0, rootState.Widget.bot.autocompleteNumResults)
      : [...state.searchResult],
}
export const mutations = {
  TOGGLE_SHOW_EDITOR(state, payload) {
    state.showEditor = payload
  },
  DISABLE_EDITOR(state) {
    state.loading = true
  },
  ENABLE_EDITOR(state) {
    state.loading = false
  },
  UPDATE_TYPING(state, payload) {
    state.customerTyping = payload
  },
  SET_TYPING_INTERVAL(state, payload) {
    state.customerTypingInterval = payload
  },
  CLEAR_TYPING_INTERVAL(state) {
    clearTimeout(state.customerTypingInterval)
  },
  UPDATE_SENDING_MESSAGE(state, payload) {
    state.sendingMessage = payload
  },
  SET_MESSAGE(state, payload) {
    state.messageToSend = payload
  },
  SET_MESSAGE_RAW(state, payload) {
    state.messageToSendRaw = payload
  },
  CLEAR_MESSAGE(state) {
    state.messageToSend = ''
    state.messageToSendRaw = ''
  },
  UPDATE_SENDING_FILE(state, payload) {
    state.sendingFiles = payload
  },
  SET_FILES(state, payload) {
    state.filesToSend = payload
  },
  CLEAR_FILES(state) {
    state.filesToSend = []
  },
  SET_SEARCH_RESULT(state, payload) {
    if (state.messageToSendRaw) {
      state.searchResult = payload
    }
  },
  CLEAR_SEARCH_RESULT(state) {
    state.searchResult = []
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const actions = {
  sendMessage({ commit, dispatch }, { html = '', raw = '' }) {
    dispatch('updateSearchingStatus', false)

    commit('DISABLE_EDITOR')
    commit('SET_MESSAGE', html)
    commit('SET_MESSAGE_RAW', raw)
    commit('UPDATE_SENDING_MESSAGE', true)
  },
  messageSent({ rootState, commit }) {
    // Preserve message during changing session to be able to send it seamless
    if (!rootState.Widget.isFallingBackToBot) {
      commit('CLEAR_MESSAGE')
      commit('ENABLE_EDITOR')
      commit('UPDATE_SENDING_MESSAGE', false)
    }
  },
  sendFiles({ commit }, payload) {
    commit('UPDATE_SENDING_FILE', true)
    commit('SET_FILES', payload)
  },
  filesSended({ commit }) {
    commit('UPDATE_SENDING_FILE', false)
    commit('CLEAR_FILES')
  },
  updateTyping({ state, commit, dispatch }, { html = '', raw = '', typing }) {
    if (state.sendingMessage) {
      return
    }

    commit('CLEAR_TYPING_INTERVAL')
    commit('SET_MESSAGE', html)
    commit('SET_MESSAGE_RAW', raw)
    commit('UPDATE_TYPING', typing)
    dispatch('updateSearchingStatus', !!raw)
    const interval = setTimeout(() => {
      commit('UPDATE_TYPING', false)
    }, 500)
    commit('SET_TYPING_INTERVAL', interval)
  },
  updateSearchingStatus({ commit }, search = false) {
    if (!search) {
      commit('CLEAR_SEARCH_RESULT')
    }
  },
  setEditorVisibility({ commit }, isVisible) {
    commit(isVisible ? 'ENABLE_EDITOR' : 'DISABLE_EDITOR')
    commit('TOGGLE_SHOW_EDITOR', isVisible)
  },
  reset({ commit }) {
    commit('RESET')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
